/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */

import { userType } from './analyticsWebTypes';
import { isType } from './isType';
import { objectValues } from './objectValues';

export function validateIdentifyEvent(userIdType: string, userId: string): void {
	if (!userIdType) {
		throw new Error('Missing userIdType');
	}

	if (!userId) {
		throw new Error('Missing userId');
	}

	if (!isType(userType, userIdType)) {
		throw new Error(
			`Invalid userIdType '${userIdType}', ` + `must be an userType: [${objectValues(userType)}]`,
		);
	}
}
